<template>
  <tab-item-template>
    <el-table
        :data="serviceRecords">
      <el-table-column
          width="80"
          align="center"
          prop="eventType"
          label="区分">
        <template #default="{row}">
          {{ eventTypes[row.eventType] }}
        </template>
      </el-table-column>

      <el-table-column
          width="160"
          prop="createdAt"
          label="記録日時">
        <template #default="{row}">
          {{ formatDateTime(row.createdAt) }}
        </template>
      </el-table-column>

      <el-table-column
          prop="serviceComponentModelName"
          label="サービス実装名">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.serviceComponentModelName"
                :value-id="row.serviceImplementationId"
                :placeholder="'\u2E3B'">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          prop="owner.name"
          label="事業者名">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.owner.name"
                :value-id="row.owner.id">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          prop="terminal.name"
          label="サイト名">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.terminal.name"
                :value-id="row.terminal.id">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>
    </el-table>
  </tab-item-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import Formatter from "@/utils/Formatter";
import { SERVICE_RECORD_EVENT_TYPES } from "@/constants";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";

export default {
  name: 'ServiceRecordImplementationTableForData',
  mixins: [
    PathInfoMixin,
    Formatter
  ],
  components: {
    TextFieldLike,
    TableInline,
    TabItemTemplate
  },
  props: {
    serviceRecords: {
      type: Array,
      required: true
    }
  },
  computed: {
    eventTypes: () => SERVICE_RECORD_EVENT_TYPES
  }
}
</script>
